import React from 'react'
import { ActivityIndicator } from 'react-native'
import { Layout } from '@ui-kitten/components'

export default function Spinner() {
  return (
    <Layout style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
      <ActivityIndicator size="large" />
    </Layout>
  )
}
